var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import mapProps from "./mapProps";
export function flattenProp(propName) {
    return mapProps(function (props) { return (__assign({}, props, props[propName])); });
}
export default flattenProp;

//# sourceMappingURL=flattenProp.js.map



//////////////////
// WEBPACK FOOTER
// ./~/reassemble/lib/flattenProp.js
// module id = 53
// module chunks = 0